export function showImg(path: string, width: number = 900, height: number = 0, format: string = 'webp'): string {
    const baseUrl: string = `${window.location.protocol}//${window.location.hostname}`;
    const slug: string = slugify(getFilenameWithoutExtension(path));
    return `${baseUrl}/image-cache/remote/${btoa(path)}/${slug}-${width}x${height}.${format}`;
}

export function slugify(str: string): string {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function getFilenameWithoutExtension(url: string): string {
    const parts = url.split('/');
    const filename = parts.pop() || '';
    const dotIndex = filename.lastIndexOf('.');
    return dotIndex !== -1 ? filename.substring(0, dotIndex) : filename;
}
